import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import Indexdata from "@/components/home/indexdata.vue";

const router = createRouter({
  routes: [
    {
      path: "/",
      redirect: "/home",
    },

    {
      path: "/home",
      name: "首页",
      component: Indexdata,
    },
  ],
  history: createWebHashHistory(),
});
export default router;
